
export interface WorkloadMenuProps {
	agentId: string;
	menuType: WorkloadMenuType;
    trigger: JSX.Element;
    totalWorkload : number;
    openOnHover?: boolean;
}

export enum WorkloadMenuType {
	CurrentAgent = 1,
    SupervisedAgent = 2
}
